// extracted by mini-css-extract-plugin
export default {"main":"cardcompany_main__Zd5lY","name":"cardcompany_name__t99NA","text":"cardcompany_text__ejip9"};